// Cross-browser helpers for the booth kiosk fullscreen mode.
// Browsers only allow entering fullscreen from a user gesture, so callers
// should trigger enterFullscreen() from a click/selection handler.

// Returns true when the document is currently displayed in fullscreen.
export const isFullscreen = () => {
    return !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
    );
};

// Request fullscreen on the given element (defaults to the whole document).
export const enterFullscreen = (target = document.documentElement) => {
    const request =
        target.requestFullscreen ||
        target.webkitRequestFullscreen ||
        target.mozRequestFullScreen ||
        target.msRequestFullscreen;
    // Swallow rejections (e.g. called without a user gesture) so callers don't break.
    if (request) return Promise.resolve(request.call(target)).catch(() => {});
    return Promise.resolve();
};

// Leave fullscreen if currently active.
export const exitFullscreen = () => {
    const exit =
        document.exitFullscreen ||
        document.webkitExitFullscreen ||
        document.mozCancelFullScreen ||
        document.msExitFullscreen;
    if (exit && isFullscreen()) return Promise.resolve(exit.call(document)).catch(() => {});
    return Promise.resolve();
};

// Toggle between entering and leaving fullscreen.
export const toggleFullscreen = (target = document.documentElement) => {
    return isFullscreen() ? exitFullscreen() : enterFullscreen(target);
};

// Subscribe to fullscreen state changes; returns an unsubscribe function.
export const onFullscreenChange = (handler) => {
    const events = ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange', 'MSFullscreenChange'];
    events.forEach((event) => document.addEventListener(event, handler));
    return () => events.forEach((event) => document.removeEventListener(event, handler));
};
